import fetcher from 'api/fetcher';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setCharges, setLoadCharges } from 'store/models/invoiceDetail';

const fetchActs = (invoiceId, from, to) => {
    return (dispatch) => {
        dispatch(setLoadCharges(true));
        const queryStr = urlParser.stringify({
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        });
        fetcher.get(`/api/v1/fixedStatistic/byInvoice/${invoiceId}?${queryStr}`).then((acts) => {
            dispatch([setLoadCharges(false), setCharges(acts)]);
        });
    };
};

export default fetchActs;
